<template>
  <v-container>
    <v-card cols="12" elevation="0">
      <v-col>
        <v-row v-html="article"></v-row>
        <v-row>
          <v-carousel
            cycle
            height="400"
            hide-delimiters
            hide-delimiter-background
            :show-arrows="false"
          >
            <v-carousel-item v-for="(item,i) in banners" :key="i">
              <v-card color="white" width="100%" elevation="0">
                <v-row>
                  <v-col align="center" justify="center">
                    <v-img
                      :aspect-ratio="8/6"
                      :min-width="200"
                      :max-width="400"
                      :max-height="400"
                      class="rcorners whiteBackground"
                      :src="item"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-card>
            </v-carousel-item>
          </v-carousel>
        </v-row>
      </v-col>
    </v-card>
  </v-container>
</template>

<script>
import { eventEmitter } from "../main";
import axios from "axios";

export default {
  components: {},
  metaInfo: {
    title: "About me",
    titleTemplate: "%s | iLook.su",
  },
  data() {
    return {
      name: "about_me",
      banners: [
        "https://file.ilook.su/public/AppInfo/images/sert/0.png",
        "https://file.ilook.su/public/AppInfo/images/sert/1.png",
        "https://file.ilook.su/public/AppInfo/images/sert/2.png",
        "https://file.ilook.su/public/AppInfo/images/sert/3.png",
        "https://file.ilook.su/public/AppInfo/images/sert/4.png",
        "https://file.ilook.su/public/AppInfo/images/sert/5.png",
        "https://file.ilook.su/public/AppInfo/images/sert/6.png",
        "https://file.ilook.su/public/AppInfo/images/sert/7.png",
        "https://file.ilook.su/public/AppInfo/images/sert/8.png",
        "https://file.ilook.su/public/AppInfo/images/sert/9.png",
        "https://file.ilook.su/public/AppInfo/images/sert/10.png",
        "https://file.ilook.su/public/AppInfo/images/sert/11.png",
        "https://file.ilook.su/public/AppInfo/images/sert/12.png",
      ],
      article: "",
    };
  },
  watch: {
    article() {
      this.$nextTick(() => {
        let titleTextEl = document.getElementById("title");
        if (titleTextEl) {
          document.title = titleTextEl.innerHTML;
        }
      });
    },
  },
  computed: {
    isSingle(){
      return location.host == "ilook.su"
    },
  },
  methods: {
    update() {
      console.log("update article");
      let config = {
        headers: {
          lang: this.$vuetify.lang.current,
        },
      };

      let type = "single"
      if (!this.isSingle){
        type = "corp"
      }

      let url = `https://file.ilook.su/AppInfo/api/article/${type}/${this.name}/`;
      axios
        .get(url, config)
        .then((response) => response.data)
        .then((data) => {
          if (data) {
            this.article = data;
          }
        })
        .catch((error) => {
          this.article = error;
        });
    },
  },
  mounted() {
    this.update();
    let sheet = document.getElementById("scrolling_sheet");
    if (sheet) {
      sheet.scroll(0, 0);
    }
  },
  created() {
    eventEmitter.$on("updateLocale", () => {
      this.update();
    });
  },

  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave");
    if (to.hash == "#scrollOnTop") {
      this.$store.commit("resetStoredPosition");
      next(to.path);
      return;
    }

    next();
  },
};
</script>


<style scoped>
.whiteBackground {
  background-color: #fff;
}
</style>